import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const pagetableColumnSingleselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],

  code: [String, Array] as PropType<string | { value: string; content: string }[]>,
})

export type PagetableColumnSingleselectProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnSingleselectProps>>>

export default defineComponent({
  name: 'OPagetableColumnSingleselect',
  inheritAttrs: false,
  props: pagetableColumnSingleselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
